module.exports = __webpack_public_path__ + "static/media/avg-score.f41dc959.svg";